// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"97a91543","564":"01aebe47","652":"cd0fa968"}[chunkId] + ".css";
};